import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CoreApisService } from '../core-apis.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-transactional-fx',
  templateUrl: './transactional-fx.component.html',
  styleUrls: ['./transactional-fx.component.scss'],
  imports: [CommonModule],
})
export class TransactionalFxComponent implements OnInit, OnDestroy {
  constructor(private coreApiPageService: CoreApisService) {
    this.subscriptions = [];
  }
  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  transactionalFxData: any;
  subscriptions: Subscription[];

  ngOnInit(): void {
    this.coreApiPageService.fxSection$.subscribe(data => {
      if (data !== null) {
        this.transactionalFxData = {
          tag: data?.components[0]?.fields?.tagText,
          title: data?.title,
          description: data?.content?.content[0]?.content[0]?.value,
          image: data?.image[0]?.fields?.file?.url,
        };
      }
    });
  }
}
